<script lang="ts">
	import TemplateInputSettings from '../Components/TemplateInputSettings.svelte';
	import type { Device } from 'src/types/Device';

	export let device: Device;
</script>

<TemplateInputSettings
	{device}
	setting="temp_anti_freeze"
	min={1}
	max={21}
	unit="°C"
	icon="far fa-thermometer-three-quarters"
/>
